import { render } from "./shopping-cart.vue?vue&type=template&id=11b463ca&scoped=true"
import script from "./shopping-cart.vue?vue&type=script&lang=js"
export * from "./shopping-cart.vue?vue&type=script&lang=js"

import "./shopping-cart.vue?vue&type=style&index=0&id=11b463ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11b463ca"

export default script